import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function DocumentStatus(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M6 6a2 2 0 012-2h8a2 2 0 012 2v13.532l-1.332-.973a2.5 2.5 0 00-3.309.32l-.979 1.057a.5.5 0 01-.738-.004l-.961-1.064a2.5 2.5 0 00-3.4-.289L6 19.586V6zm2-4a4 4 0 00-4 4v14.616c0 1.251 1.443 1.952 2.427 1.179l2.09-1.644a.5.5 0 01.68.058l.962 1.064a2.5 2.5 0 003.688.022l.98-1.057a.5.5 0 01.661-.064l2.127 1.553c.992.724 2.385.016 2.385-1.211V6a4 4 0 00-4-4H8zm7.78 7.625a1 1 0 10-1.56-1.25l-3.303 4.128-1.21-1.21a1 1 0 00-1.414 1.414l2 2a1 1 0 001.488-.082l4-5z",
    clipRule: "evenodd"
  }));
}

export default DocumentStatus;